import { useMutation } from '@tanstack/react-query';

import type { BackendTypes } from '@tf/api';
import { BackendClient, PublicApiClient } from '@tf/api';

// TODO: Support API changes
export const useDownloadFileMutation = () => {
	return useMutation({
		mutationFn: async ({ file }: { file: BackendTypes.FieldFile }) => {
			const res = await BackendClient.getInstance().download(file.storageKey);
			const blob = await res.arrayBuffer();

			const url = URL.createObjectURL(new Blob([blob]));
			const a = document.createElement('a');
			a.href = url;
			a.download = file.filename;
			a.click();
			window.URL.revokeObjectURL(url);
		},
	});
};

export const downloadFile = async (objectId: string) => {
	const res = await PublicApiClient.getInstance().request({
		path: `/v1/data/general_graph/object/${encodeURIComponent(objectId)}/download`,
	});
	return res.blob();
};

export const isPreviewableFile = (mimeType: string): boolean => {
	const type = mimeType?.toLowerCase();
	if (!type) return false;

	return (
		type.startsWith('application/pdf') ||
		(type.startsWith('image/') &&
			(type === 'image/png' || type === 'image/jpeg' || type === 'image/jpg' || type === 'image/gif'))
	);
};
